/**
 * @generated SignedSource<<3180d50dca5fd6ca6b8a271c25e54997>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateWidgetEmployeeScheduleInput = {
  setTeamIds?: ReadonlyArray<string> | null;
};
export type WSEmployeeScheduleMutation$variables = {
  input: UpdateWidgetEmployeeScheduleInput;
  storecastId: string;
  widgetId: string;
};
export type WSEmployeeScheduleMutation$data = {
  readonly dashboard: {
    readonly updateWidgetEmployeeSchedule: {
      readonly id: string;
      readonly teams: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  };
};
export type WSEmployeeScheduleMutation = {
  response: WSEmployeeScheduleMutation$data;
  variables: WSEmployeeScheduleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "widgetId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          },
          {
            "kind": "Variable",
            "name": "widgetId",
            "variableName": "widgetId"
          }
        ],
        "concreteType": "WidgetEmployeeSchedule",
        "kind": "LinkedField",
        "name": "updateWidgetEmployeeSchedule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "teams",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WSEmployeeScheduleMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WSEmployeeScheduleMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "55820ff75a31ab1bfcb07b4eac7c5d39",
    "id": null,
    "metadata": {},
    "name": "WSEmployeeScheduleMutation",
    "operationKind": "mutation",
    "text": "mutation WSEmployeeScheduleMutation(\n  $storecastId: ID!\n  $widgetId: ID!\n  $input: UpdateWidgetEmployeeScheduleInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    updateWidgetEmployeeSchedule(input: $input, widgetId: $widgetId) {\n      id\n      teams {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "575a0ec929a3812d412187967e27cf6e";

export default node;
